import script from "./CalculationVersionsRow.vue?vue&type=script&setup=true&lang=js"
export * from "./CalculationVersionsRow.vue?vue&type=script&setup=true&lang=js"

import "./CalculationVersionsRow.vue?vue&type=style&index=0&id=61d601fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d601fb"]])

export default __exports__